var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-primary-blue-10 w-max cursor-default"},[_c('MetaPlatformIcon'),_c('BaseText',{staticClass:"text-primary-blue-300",attrs:{"type":"label","size":"xs"}},[_vm._v(" Meta Only ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }